import styled, { css } from 'styled-components';
import Chck from './Check';
import { getColor } from 'core/utils/Styles';

export const ThankWrapper = styled.div`
	position: relative;
	z-index: 1;
	color: ${getColor('lavender')};
	text-align: center;
	max-width: 480px;
	margin: 0 auto;
`;

export const Title = styled.h4`
	margin: 0;
	margin-bottom: 8px;
	font-size: 24px;
	letter-spacing: 0.3px;
	line-height: 1;
	font-weight: 700;
`;

export const Message = styled.p`
	margin: 0;
	font-size: 14px;
	letter-spacing: 0.3px;
	line-height: 1.2;

	& + & {
		margin-top: 16px;
	}
`;

export const Check = styled(Chck)`
	display: block;
	margin: 0 auto 8px;
`;
